<!--
    设计师首页
-->
<template>
    <div class="content_warp">
        <template v-if="objDesigner">
            <!-- 没有项目且不是筛选 -->
            <div v-if="arrProjectList.length == 0 && sSearchtext == '' && nScreenKey == 0" class="default_wrap">
                <img src="~@/assets/images/user/housev2/default_img.png" alt="">
                <h1>暂未查询到您的项目交付档案</h1>
                <template v-if="true">
                    <!--冷暖风水交付书主要针对购买冷暖风水系统产品的 -->
                    <p>项目交付档案主要针对购买A.O.史密斯智慧集成系统的<br/>用户开发。请使用您推荐客户时预留给销售人员的手机号<br/> 进入查询，如有疑问可咨询当地对接的销售人员。</p>
                </template>
            </div>
            <div v-else class="index_wrap">
                <div class="user_info">
                    <img class="head" src="~@/assets/images/user/housev2/head_dome.png" alt="">
                    <div class="info">
                        <p class="name">
                            {{ objDesigner.designer_name }}
                            <span class="phone">{{ objDesigner.designer_phone }}</span>
                        </p>
                        <p class="company">{{ objDesigner.company_name }}</p>
                    </div>
                </div>
                <div class="order_info">
                    <div class="data_item">
                        <div class="name">签约(单)</div>
                        <div class="num">{{ objContractNum.count || 0 }}</div>
                    </div>
                    <div class="data_item">
                        <div class="name">施工中(户)</div>
                        <div class="num">{{ objContractNum.construct || 0 }}</div>
                    </div>
                    <div class="data_item">
                        <div class="name">竣工(户)</div>
                        <div class="num">{{ objContractNum.compelet || 0 }}</div>
                    </div>
                </div>
                <!--                <div class="project_box">-->
                <div :class="['project_box',{'project_box2':isShowShare}]">
                    <div class="search_box">
                        <div class="search_title">客户项目进展</div>
                        <div class="search">
                            <img class="search_icon" src="~@/assets/images/designer/search_icon.png" alt="">
                            <input class="input" v-model="sSearchtext" placeholder="搜索客户" @input="onSearchInput"
                                   placeholder-class="placeholder_class"></input>
                            <img class="screen_icon" src="~@/assets/images/designer/screen_icon.png"
                                 @click="showScreenPopup" alt="">
                        </div>
                    </div>
                    <div class="project_list">
                        <template v-if="arrProjectList.length == 0">
                            <div class="project_default">
                                <img src="~@/assets/images/user/housev2/default_img.png" alt="">
                                <p>暂未查询到您的项目交付档案</p>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="(item,index) in arrProjectList" :key="index" class="project-all">
                                <div class="project-box" @click="touchPrject(item)">
                                    <div class="project-top">
                                        <div class="title">{{ item.new_name }}</div>
                                        <div class="const" v-if='item.new_status == 0'>无合同</div>
                                        <div class="const" v-if='item.new_status == 1'>未签约</div>
                                        <div class="const" v-if='item.new_status == 2'>未进场</div>
                                        <div class="const" v-if='item.new_status == 3'>未完工</div>
                                        <div class="const const2" v-if='item.new_status == 4'>已完工</div>
                                    </div>
                                    <div class="lable">
                                        <div class="square">{{ item.name ? item.name : '' }}</div>
                                        <div class="room">{{ item.new_telephone ? item.new_telephone : '' }}</div>
                                    </div>
                                    <div class="line-box">
                                        <div class="garden-box-wit">
                                            <div :class="item.new_status >= 1 ?'garden-box':'garden-box-item'"></div>
                                        </div>
                                        <div class="garden-box-wit">
                                            <div :class="item.new_status >= 2 ?'garden-box':'garden-box-item'"></div>
                                        </div>
                                        <div class="garden-box-wit">
                                            <div :class="item.new_status >= 3 ?'garden-box':'garden-box-item'"></div>
                                        </div>
                                        <div class="garden-box-wit">
                                            <div :class="item.new_status >= 4 ?'garden-box':'garden-box-item'"></div>
                                        </div>
                                        <div class="short-line"
                                             :style="{width: ( (item.new_status - 1) * 30 + 5 + (item.new_status==4? 5 :'') + '%')}"></div>
                                        <div class="long-line"
                                             :style="{width:  ((item.new_status==4 ? 0 : 25 ) + (4 - item.new_status)*90 + 'px')}">
                                        </div>
                                    </div>
                                    <div class="process">
                                        <div class="process-title">签订<br/>合同</div>
                                        <div class="process-title">设计<br/>方案</div>
                                        <div class="process-title">施工<br/>验收</div>
                                        <div class="process-title">无忧<br/>售后</div>
                                    </div>
                                </div>
                                <div class="project-bottom" @click="touchPrject(item)">
                                    <div class="bottom-title">项目进度总览</div>
                                    <div class="bottom-img"><img src="~@/assets/images/project/navgetTo.png"/></div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <!--  筛选弹框 -->
            <van-popup v-model:show="isShowScreen" round position="bottom">
                <div class="screen_box">
                    <div class="title">客户项目进展</div>
                    <div class="screen_list">
                        <template v-for="(item,index) in arrSreenItem">
                            <div :key="item.key" :class="['screen_item',{'screen_item_act':index == nScreenIndex}]"
                                 @click="touchScreenItem(index)">
                                {{ item.txt }}
                            </div>
                        </template>
                    </div>
                    <div class="screen_btns">
                        <van-button class="btn_reset" @click="touchScreenItem(nScreenIndex)">重置</van-button>
                        <van-button class="btn_screen" @click="touchScreen">筛选</van-button>
                    </div>
                </div>
            </van-popup>

            <share ref="myShare" v-if="isShowShare && arrProjectList.length > 0" :isHouse="false"
                   :isFixed="true"></share>
            <!-- 我要吐槽 -->
            <div v-if="arrProjectList.length > 0" :class="['venting-box', {'venting-box2':isShowShare}]"
                 @click="touchVenting">
                <img class="venting-icon" src="~@/assets/images/designer/venting-icon.png" alt=""/>
                我要吐槽
            </div>
        </template>
    </div>
</template>

<script>
import {getDesignInfo, getSearchData, getProjectList} from "@/js/designer/index.js";
import router from "@/router";
import share from "../components/share.vue"
import storage from "@/libsV2/storage";

export default {
    name: "DesignerIndex_useKP",
    components: {
        share
    },
    data() {
        return {
            designerPhone: '',
            objDesigner: {},
            objContractNum: {},
            isShowScreen: false,
            nScreenIndex: -1,
            nScreenKey: 0,
            arrSreenItem: [],
            sSearchtext: '',
            searchInputTimer: null,
            arrProjectList: [],
            isShowShare: false,
            query: {},
        }
    },
    created() {
        this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
        $init(() => {
            this.$oInitData.designerInfo({
                h5_user_id: this.$storage.getStorage("user_id"),
            }).then((res) => {
                let objData = this.$route.query;
                this.query = this.$route.query;
                if (objData.sampleroom == 2) {
                    this.isShowShare = true;
                }
                this.designerPhone = res.phone;
                if (res.phone) {
                    this.pageInit();
                } else {
                    this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                }
            }).catch((error) => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            });
        })
    },
    activated() {
        if (this.$route.query.sampleroom == 2 && this.query.contractid != this.$route.query.contractid) {
            $init(() => {
                this.$oInitData.designerInfo({
                    h5_user_id: this.$storage.getStorage("user_id"),
                }).then((res) => {
                    this.query = this.$route.query;
                    this.isShowShare = true;
                    this.designerPhone = res.phone;
                    if (res.phone) {
                        this.pageInit();
                    } else {
                        this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                    }
                }).catch((error) => {
                    this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                });
            })
        }
        console.log('3212')
    },
    methods: {
        pageInit() {
            this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
            Promise.all([
                this.getDesignInfoFun(),
                this.getSearchDataFun(),
                this.getProjectListFun(),
            ]).then(() => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            }).catch((err) => {
                console.log(err);
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            })
        },
        //获取设计师信息
        getDesignInfoFun() {
            return new Promise((resolve, reject) => {
                getDesignInfo({
                    mobile: this.designerPhone,
                    // mobile: '18651832289',
                    // contract_id: 'a0c8d8c7-2e63-43a5-bd94-d8520ce589a0',
                }).then((res) => {
                    let result = res.data.result;
                    console.log('getDesignInfo', result)
                    this.objDesigner = result.design_info;
                    this.objDesigner.designer_phone = this.objDesigner.designer_phone.slice(0, 3) + '****' + this.objDesigner.designer_phone.slice(-4);
                    this.objContractNum = result.contract_num;
                    resolve()
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        //获取项目列表筛选项
        getSearchDataFun() {
            return new Promise((resolve, reject) => {
                getSearchData().then((res) => {
                    let result = res.data.result;
                    console.log('getSearchData', result)
                    let arrState = [];
                    for (const key in result.state) {
                        arrState.push({
                            key: key,
                            txt: result.state[key]
                        })
                    }
                    this.arrSreenItem = arrState;
                    resolve()
                })
            })
        },
        //获取项目列表
        getProjectListFun() {
            return new Promise((resolve, reject) => {
                getProjectList({
                    word: this.sSearchtext,
                    state: this.nScreenKey > 0 ? this.nScreenKey : 0,
                    mobile: this.designerPhone,
                    // mobile: '18651832289',
                }).then((res) => {
                    let result = res.data.result;
                    console.log('getProjectList', result)
                    this.arrProjectList = result.lists;
                    resolve()
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        showScreenPopup() {
            this.isShowScreen = !this.isShowScreen;
        },
        touchScreenItem(i) {
            if (this.nScreenIndex !== i) {
                this.nScreenIndex = i;
            } else {
                this.nScreenIndex = -1;
            }
        },
        touchReset() {
            this.nScreenIndex = -1;
            this.nScreenKey = 0;
        },
        onSearchInput(e) {
            if (this.searchInputTimer != null) {
                clearTimeout(this.searchInputTimer);
                this.searchInputTimer = null;
            }
            this.searchInputTimer = setTimeout(() => {
                this.searchInputTimer = null;
                this.$store.commit("loadSwitch", true); // 页面loading开启
                this.getProjectListFun().then(() => {
                    this.$store.commit("loadSwitch", false); // 页面loading关闭
                })
            }, 2000)
        },
        touchScreen() {
            this.nScreenKey = this.nScreenIndex >= 0 ? this.arrSreenItem[this.nScreenIndex].key : 0;
            this.$store.commit("loadSwitch", true); // 页面loading开启
            this.getProjectListFun().then(() => {
                this.$store.commit("loadSwitch", false); // 页面loading关闭
            })
            this.showScreenPopup()
        },
        touchPrject(item) {
            this.$storage.setStorage('designer_prject', {
                new_srv_projectmgnid: item.new_srv_projectmgnid,
                new_account_id: item.new_account_id,
                new_contract_id: item.new_contract_id,
                new_name: item.new_name,
            });
            this.$router.push({
                path: `/designer/project/index`,
                query: {
                    ...this.$route.query
                }
            })
        },
        touchVenting() {
            this.$router.push({
                path: `/designer/venting/index`,
                query: {
                    ...this.$route.query
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>
